import { fork, take, call, put, all, takeLatest } from "redux-saga/effects";

import {
  assignToTeamsResponse,
  doAssignTeamMatesRes,
  getAssignUserResponse,
  getCompletedCourseListRes,
  getOfficeListRes,
  getTeamListResponse,
  getTeamMatesRes,
  getUsersByOfficeListResponse,
  getFilterLpResponse,
  getAssignUsersListResponse,
  changeDueDateAssignUserResponse,
  getReaReportRes,
  getManagerReportRes,
  getCourseReportRes,
  getProviderReportRes,
  getCategoryByEntityIDResponse,
  getAvailableLPByEntityIDResponse,
  getBrokerageFilterListResponse,
} from "./actions";
import types from "./types";
import { apiDirect, postAPIWithoutModule } from "../../api/generic";

export function* doGetTeamMatesList() {
  while (true) {
    const { payload } = yield take(types.GET_TEAMMATES_REQ);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getTeamMatesRes(response));
  }
}

export function* doGetREAReportList(action) {
  // while (true) {
    // const { payload } = yield take(types.GET_REA_LIST_REPORT_REQ);
    console.log('rea load 4', action?.payload)
    if (action?.payload) {
      const response = yield call(postAPIWithoutModule, action.payload);
      yield put(getReaReportRes(response));
    }
  // }
}

export function* doGetREAReportListTakeLatest() {
  yield takeLatest(types.GET_REA_LIST_REPORT_REQ, doGetREAReportList)
  // while (true) {
  // }
}

export function* doGetCourseReportList(action) {
  // while (true) {
    // const { payload } = yield take(types.GET_COURSE_LIST_REPORT_REQ);
  if (action?.payload) {
    const response = yield call(postAPIWithoutModule, action.payload);
    yield put(getCourseReportRes(response));
  }
  // }
}

export function* doGetCourseReportListTakeLatest() {
  yield takeLatest(types.GET_COURSE_LIST_REPORT_REQ, doGetCourseReportList)
}

export function* doGetManagerReportList(action) {
  // while (true) {
    // const { payload } = yield take(types.GET_MANAGER_LIST_REPORT_REQ);
    if (action?.payload) {
      const response = yield call(postAPIWithoutModule, action.payload);
      yield put(getManagerReportRes(response));
    }
  // }
}

export function* doGetManagerReportListTakeLatest() {
  yield takeLatest(types.GET_MANAGER_LIST_REPORT_REQ, doGetManagerReportList)
}

export function* doGetProviderReportList() {
  while (true) {
    const { payload } = yield take(types.GET_PROVIDER_LIST_REPORT_REQ);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getProviderReportRes(response));
  }
}

export function* doAssignTeamMates() {
  while (true) {
    const { payload } = yield take(types.ASSIGN_TEAMMATES_REQ);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(doAssignTeamMatesRes(response));
  }
}

export function* doGetOfficeList(action) {
  // while (true) {
    // const { payload } = yield take(types.SEARCH_OFFICE_LIST_REQ);
    if (action?.payload) {
      const response = yield call(postAPIWithoutModule, action.payload);
      yield put(getOfficeListRes(response));
    }
  // }
}

export function* doGetOfficeListTakeLatest() {
  yield takeLatest(types.SEARCH_OFFICE_LIST_REQ, doGetOfficeList)
}

export function* doGetCompletedCourseList() {
  while (true) {
    const { payload } = yield take(types.COMPLETED_COURSE_LIST_REQ);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCompletedCourseListRes(response));
  }
}

export function* doGetUsersByOfficeList() {
  while (true) {
    const { payload } = yield take(types.GET_USERS_BY_OFFICE_LIST);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getUsersByOfficeListResponse(response));
  }
}

export function* doGetTeamsListReq() {
  while (true) {
    const { payload } = yield take(types.GET_TEAMS_LIST_REQ);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getTeamListResponse(response));
  }
}

export function* doAssignToTeamsReq() {
  while (true) {
    const { payload } = yield take(types.ASSIGN_TO_TEAMS_REQ);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(assignToTeamsResponse(response));
  }
}

export function* doGetAssignedUser() {
  while (true) {
    const { payload } = yield take(types.GET_ASSIGN_USERS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getAssignUserResponse(response));
  }
}
export function* doChooseLp(action) {
  // while (true) {
    // const { payload } = yield take(types.CHOOSE_LP_REPORT_FILTER);
    if (action?.payload) {
      const response = yield call(postAPIWithoutModule, action.payload);
      yield put(getFilterLpResponse(response));
    }
  // }
}

export function* doChooseLPTakeEvery() {
  yield takeLatest(types.CHOOSE_LP_REPORT_FILTER, doChooseLp)
}


export function* doGetAssignUserList() {
  while (true) {
    const { payload } = yield take(types.GET_ASSIGN_USER_LIST);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getAssignUsersListResponse(response));
  }
}

export function* doChangeDueDateAssignUserList() {
  while (true) {
    const { payload } = yield take(types.CHANGE_DUE_DATE_ASSIGN_USER_LIST);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(changeDueDateAssignUserResponse(response));
  }
}

export function* doGetCategoryByEntityID() {
  while (true) {
    const { payload } = yield take(types.GET_CATEGORY_BY_ENTITY_ID);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCategoryByEntityIDResponse(response));
  }
}

export function* doAvailableLPByEntityID() {
  while (true) {
    const { payload } = yield take(types.AVAILABLE_LP_BY_ENTITY_ID);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getAvailableLPByEntityIDResponse(response));
  }
}

export function* doGetBrokerageFilterList() {
  while (true) {
    const { payload } = yield take(types.GET_BROKERAGE_FILTER_LIST_REQ);
    const response = yield call(apiDirect, payload);
    yield put(getBrokerageFilterListResponse(response));
  }
}



function* getRes() {
  yield fork(doGetTeamMatesList);
  // yield fork(doGetREAReportList);
  yield fork(doGetREAReportListTakeLatest);
  // yield fork(doGetCourseReportList);
  yield fork(doGetCourseReportListTakeLatest);
  // yield fork(doGetManagerReportList);
  yield fork(doGetManagerReportListTakeLatest);
  yield fork(doGetProviderReportList);
  yield fork(doAssignTeamMates);
  // yield fork(doGetOfficeList);
  yield fork(doGetOfficeListTakeLatest);
  yield fork(doGetCompletedCourseList);
  yield fork(doGetUsersByOfficeList);
  yield fork(doGetTeamsListReq);
  yield fork(doAssignToTeamsReq);
  yield fork(doGetAssignedUser);
  // yield fork(doChooseLp);
  yield fork(doChooseLPTakeEvery);
  yield fork(doGetAssignUserList);
  yield fork(doChangeDueDateAssignUserList);
  yield fork(doGetCategoryByEntityID);
  yield fork(doAvailableLPByEntityID);
  yield fork(doGetBrokerageFilterList);
}
export default getRes;
